
    import * as React from 'react';

    const Dollar20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><path d="M14.66 13.54C14.66 15.44 13 16.78 10.78 16.98V18.98H9.56V16.96C7.5 16.72 5.64 15.44 5.5 13.16H6.98C7.04 14.42 8.28 15.42 9.56 15.68V10.84L8.98 10.68C7.1 10.14 6.02 9.06 6.02 7.18C6.02 5.34 7.62 3.98 9.56 3.76V1.74H10.78V3.76C12.5 4 14.3 5.18 14.46 7.34H12.98C12.82 6.02 11.9 5.24 10.78 5.02V9.78L11.7 10.04C13.6 10.6 14.66 11.6 14.66 13.54ZM9.44 9.38L9.56 9.42V5C8.22 5.16 7.4 5.96 7.4 7.18C7.4 8.28 8 8.96 9.44 9.38ZM10.78 15.72C12.12 15.56 13.28 14.76 13.28 13.54C13.28 12.38 12.7 11.76 11.24 11.34L10.78 11.2V15.72Z" /></svg>
        </div>
      );
    };

    Dollar20.displayName = 'Dollar20';

    export default Dollar20;
  